import { SpecialistReview } from '@mindly/ui-components';

export enum OnBoardingTypes {
  QUESTION = 'question',
  INFO = 'info',
  RESULT = 'result',
  RESULT_INFO = 'result-info',
  REVIEWS = 'reviews',
  SPECIALISTS_LIST = 'specialists-list',
}

export type OnBoardingAnswer = {
  id: string;
  title: string;
  popup?: string;
};

export type OnBoardingQuestion = {
  id: string;
  question: string;
  description: string;
  is_multiple?: boolean;
  answers: OnBoardingAnswer[];
  img_link?: string;
  hideHeader?: boolean;
  hideBackButton?: boolean;
  hideContinueButton?: boolean;
};

export type OnBoardingInfo = {
  id: string;
  text: string;
  whiteBg?: boolean;
  showSlider?: boolean;
  showReviews?: boolean;
  buttonLabel?: string;
  isAnalyseAnswersPage?: boolean;
  hideHeader?: boolean;
  hideBackButton?: boolean;
};

export type OnBoardingVars = {
  [key: string]: string;
};

export type OnBoardingMap = {
  type: OnBoardingTypes;
  id: string;
  next_steps?: OnBoardingMap[];
  answers?: {
    id: string;
    next_steps?: OnBoardingMap[];
  }[];
};

export type OnBoardingAvailableVars = {
  id: string;
  vars: {
    name: string;
    value: string;
  }[];
};

export type OnBoardingAnswerConditions = {
  id: string;
  conditions: string;
};

export type OnBoarding = {
  name: string;
  lang: string;
  map_data: OnBoardingMap[];
  vars: OnBoardingVars;
  available_vars: OnBoardingAvailableVars[];
  answer_conditions?: OnBoardingAnswerConditions[];
  main_page: string;
  button_label: string;
  show_additional_button?: boolean;
  additional_button_label?: string;
  show_mindly_logo?: boolean;
  show_close_button?: boolean;
  onboarding_key: string;
};

export type OnBoardingStepType = {
  type: OnBoardingTypes;
  id: string;
};

export type OnBoardingSelectedAnswers = {
  [key: string]: string[];
};

export type OnBoardingState = {
  id: string | null;
  questions: OnBoardingQuestion[];
  infos: OnBoardingInfo[];
  reviews: {
    limit: number;
    offset: number;
    isDisabled: boolean;
    data: SpecialistReview[];
  };
  map_data: OnBoardingMap[];
  steps: OnBoardingStepType[];
  vars: OnBoardingVars;
  available_vars: OnBoardingAvailableVars[];
  answer_conditions?: OnBoardingAnswerConditions[];
  selectedAnswers: OnBoardingSelectedAnswers;
  currentStep: OnBoardingMap | null;
  isLoading: boolean;
  main_page: string;
  name: string;
  button_label: string;
  show_additional_button?: boolean;
  additional_button_label?: string;
  register_user_id: string | null;
  redirect_token: string | null;
  show_mindly_logo?: boolean;
  show_close_button?: boolean;
  onboarding_key?: string | null;
  lang: string;
};
